import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IModule, IOnChangesObject, IPromise, IQService, IScope, ITimeoutService, IWindowService, resource} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Debugger} from "debug";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {FavorittTjeneste} from "../../../../../felles/tjenester/modulspesifikke/FavorittTjeneste";
import {BeregnetMøtevarighet, MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";
import {ProtokollRessurs} from "../../../../../felles/tjenester/ressurser/ProtokollRessurs";
import {DokumentRessurs} from "../../../../../felles/tjenester/ressurser/DokumentRessurs";
import {IntroJsTjeneste} from "../../../../../felles/tjenester/IntroJs";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";
import {MeldingTilBruker, Varighet} from "../../../../../felles/tjenester/MeldingTilBruker";
import {TransitionService} from "@uirouter/angularjs";
import {VisSkjermingDialog} from "../../modale/visSkjermingDialog/visSkjermingDialog";
import {RegistrerEksterntSignertProtokollDialog} from "../../modale/registrerEksterntSignertProtokollDialog/registrerEksterntSignertProtokollDialog";
import {MøtedokumentValgDialog} from "../../modale/møtedokumentValgDialog/møtedokumentValgDialog";
import {RessursFeilhåndtering} from "../../../../../felles/tjenester/RessursFeilhåndtering";
import moment from "moment";
import {MøteTjeneste} from "../../MøteTjeneste";
import {gettextCatalog} from "angular-gettext";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {IStateParamsService} from "angular-ui-router";
import {AvsluttSigneringsprosessDialog} from "../../modale/avsluttSigneringsprosess/avsluttSigneringsprosessDialog";
import {SendPåminelseOmSigneringDialog} from "../../../dokument/modale/sendPåminelseOmSignering/sendPåminelseOmSigneringDialog";
import {BasisKontroller} from "../../../basis/BasisKontroller";
import {erIkkeNill} from "felles/stoettefunk/nillsjekk";
import {kallNedgradertNg2TjenesteVedEndring, MøteDatatjenesteForAjs, Ng2DialogTjenesterForAjs, PresentasjonsmodusTjenesteForAjs, SakDatatjenesteForAjs, SakstidspunkterForAjs, ValgtSakRegisterForAjs} from "web/nedgraderteNg2Tjenester";
import {kopierFraAjsTilNg2, kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {SakRessurs} from "felles/tjenester/ressurser/SakRessurs";
import {trimTilNull} from "felles-ng2/støttefunksjoner/strenger";
import {DatoPerioder} from "felles/stoettefunk/datoPerioder";
import {GenerellEpostTilMedlemmerSpesifikasjon, MøteId, MøteModell, SendEpostResultatModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {omsluttLeveringIAjsApplyAsync, takeUntilAjs$destroy} from "felles/ng2/rxjsHjelpere";
import {FeilhåndteringsstrategiForDataOgMeta, Leveringsvalg} from "felles-ng2/tjenester/datalager/datatjeneste";
import {Subject} from "rxjs";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Møtedatoer} from "felles/tjenester/møte/Møtedatoer";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {Steg} from "web-ng2/moduler/møte/modale/møte-rediger-dialog/møte-rediger-dialog";
import SakListeOgDetaljerKomponent from "web-ng2/moduler/sak/komponenter/sak-liste-og-detaljer/sak-liste-og-detaljer";

require('./møte.scss');
const debug: Debugger = require('debug')('MøteKontroller');

export class MøteKontroller implements IController {

    static eventer = {scrollTilSignering: 'MøteKontroller.scrollTilSignering'};

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMøte', {
                bindings: {id: '<', sakId: '<', aktivArkfane: '<'},
                controller: MøteKontroller.forInjisering(),
                template: require('./møte.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$timeout,
            regNavn.ng.$window,
            regNavn.ng.$q,
            regNavn.ng.ui.$stateParams,
            regNavn.ng.ui.$transitions,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            FavorittTjeneste.regNavn,
            MøteTjeneste.regNavn,
            MøteRessurs.regNavn,
            GruppeRessurs.regNavn,
            ProtokollRessurs.regNavn,
            DokumentRessurs.regNavn,
            IntroJsTjeneste.regNavn,
            WebNavigasjon.regNavn,
            ModelloppdateringTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ng2RegNavn.Ng2DialogTjenesterForAjs,
            ng2RegNavn.MøteDatatjenesteForAjs,
            ng2RegNavn.SakstidspunkterForAjs,
            ng2RegNavn.PresentasjonsmodusTjenesteForAjs,
            ng2RegNavn.ValgtSakRegisterForAjs,
            MøteKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $timeout: ITimeoutService,
                private $window: IWindowService,
                private $q: IQService,
                private $stateParams: IStateParamsService,
                private $transitions: TransitionService,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private favorittTjeneste: FavorittTjeneste,
                private møteTjeneste: MøteTjeneste,
                private møteRes: MøteRessurs,
                private gruppeRes: GruppeRessurs,
                private protokollRes: ProtokollRessurs,
                private dokumentRes: DokumentRessurs,
                private introJs: IntroJsTjeneste,
                private webNavigasjon: WebNavigasjon,
                private modelloppdatering: ModelloppdateringTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private ng2DialogTjenesterForAjs: Ng2DialogTjenesterForAjs,
                private møteDatatjenesteForAjs: MøteDatatjenesteForAjs,
                private sakstidspunkterForAjs:SakstidspunkterForAjs,
                private presentasjonsmodusTjenesteForAjs:PresentasjonsmodusTjenesteForAjs,
                private valgtSakRegisterForAjs:ValgtSakRegisterForAjs) {
        //$onChanges kalles før $onInit - kaller derfor lastMøteVedOnChanges() i konstruktør og ikke i $onChanges
        this.lastMøteVedOnChanges();
        this.lyttTilPresentasjonsmodus();
        this.transkripsjonFeatureAktivert = this.kontekst.erFeatureAktivert('ki');
    }

    /** forespurt møte.id */
    id: string; //settes via bindings/$onChanges
    /** forespurt initiell arkfane */
    aktivArkfane: 'saker' | 'protokoll' | 'avstemning' | 'endringshendelser' = 'saker';//settes via bindings/$onChanges

    /** forespurt sak.id - satt dersom bruker har navigert til en sak */
    sakId: string; //settes via $transitions.onSuccess

    moete: l.MøteModell;
    moeteNg2: MøteModell;
    gruppe: l.EnkelGruppeModell;

    beregnetSluttDato: BeregnetMøtevarighet;

    visIntroJs = true;
    visSendingInnkalling = false;
    viserRedigerProtokoll = false;
    redigeringMulig = false; //hvorvidt bruker har nødv rolle for å kunne redigere møte
    protokollSkalsigneresAvNoen = false;
    protokolSkalSigneresAvBruker = false;
    flerdagsmoete = false;
    presentasjonsmodusAktivert = false;
    transkripsjonFeatureAktivert = false;

    //settes i template, brukes ved aktivering av rediger-rekkefølge via møte-meny, se lyttTilNavigasjon()
    sakListeOgDetaljerKomponent:SakListeOgDetaljerKomponent = null;

    private tilAvregistrering: Function[] = [];
    private vedEndringer = new Subject<IOnChangesObject>();

    viserMenypunktMarkerProtokollSomFerdigSignert() {
        if (!this.redigeringMulig || !this.moete) return false;
        return this.moete.protokollSigneringStatus == l.SigneringStatus.tilSignering ||
            this.moete.protokollSigneringStatus == l.SigneringStatus.delvisSignert;
    }

    navigerTilSignerProtokoll() {
        this.møteTjeneste.signerProtokoll(this.aktivtMøteId());
    }

    navigerTilForrigeMoete() {
        this.møteRes.finnSisteMøteFør(this.moete.id, true).$promise
            .then(møte => {
                if (!møte.id)
                    return this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Dette er første møte i gruppen"), Varighet.timeout);
                this.webNavigasjon.gåTilMøte(møte.id);
            });
    }

    navigerTilNesteMoete() {
        this.møteRes.finnFørsteMøteEtter(this.moete.id, true).$promise
            .then(møte => {
                if (!møte.id)
                    return this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Dette er siste møte i gruppen"), Varighet.timeout);
                this.webNavigasjon.gåTilMøte(møte.id);
            });
    }

    aktivArkfaneSaker() {
        return this.aktivArkfane === 'saker';
    }

    aktivArkfaneProtokoll() {
        return this.aktivArkfane === 'protokoll';
    }

    aktivArkfaneAvstemning() {
        return this.aktivArkfane === 'avstemning';
    }

    aktivArkfaneEndringshendelser() {
        return this.aktivArkfane === 'endringshendelser';
    }

    moetedetaljerSomPromise(): IPromise<l.MøteModell> {
        return this.$q.resolve(this.moete);
    }

    navigasjonDeaktivert(){
        return this.webNavigasjon.navigasjonDeaktivert();
    }

    rediger() {
        this.møteTjeneste.redigerMøteDialog(this.moete.id);
    }

    redigerMoeteRepresentasjon() {
        this.møteTjeneste.redigerMøteDialog(this.moete.id, Steg.representasjon);
    }

    endreSaksrekkefoelge(){
        this.webNavigasjon.gåTilRedigerSaksrekkefølge(this.moete.id);
    }

    kopier() {
        this.ng2DialogTjenesterForAjs.møteKopierDialog(kopierFraAjsTilNg2(this.moete), kopierFraAjsTilNg2(this.gruppe));
    }

    slett(feilMøtenummerAngitt = false) {
        let htmlInnhold = '';
        if (DatoPerioder.erPassert(this.moete.dato))
            htmlInnhold = '<p class="std-font-err-farge">' + this.gettextCatalog.getString('Du er i ferd med å slette et avholdt møte!') + '</p>';
        htmlInnhold = htmlInnhold + '<p>' +
          this.gettextCatalog.getString('Bekreft at du vil slette <span class="std-fet">{{tittel}} {{nummer}}</span> den {{dato}} - {{gruppetittel}} i {{organisasjonsnavn}} med <span class="std-fet">{{antsaker}} saker og {{antdokumenter}} saksdokumenter</span>.',
            {
                tittel: this.moete.tittel,
                nummer: this.moete.nummer,
                dato: moment(this.moete.dato.start).format('DD.MM.YYYY'),
                gruppetittel: this.gruppe.tittel,
                organisasjonsnavn: this.gruppe.organisasjonsnavn,
                antsaker: SakRessurs.sakssaker(this.moete).length,
                antdokumenter: SakRessurs.sakssaker(this.moete).map(s => s.dokumenter.length).reduce((a, b) => a + b, 0)
            }) +
          '</p>';
        htmlInnhold = htmlInnhold + '<p>' + this.gettextCatalog.getString('Angi møtets møtenummer ({{nummer}}) for å bekrefte sletting.', {nummer: this.moete.nummer}) + '</p>';
        if (feilMøtenummerAngitt)
            htmlInnhold = htmlInnhold + '<p class="std-font-err-farge">' + this.gettextCatalog.getString('Feil møtenummer angitt.') + '</p>';

        var bekreft = this.$mdDialog.prompt()
          .title(this.gettextCatalog.getString('Bekreft sletting av møte'))
          .htmlContent(`<div class="wt-dialog-prompt-kropp">${htmlInnhold}</div>`)
          .placeholder('møtenummer')
          .required(true) //årsak må angis
          .ok(this.gettextCatalog.getString('Slett møte'))
          .cancel(this.gettextCatalog.getString('Avbryt'));
        this.$mdDialog.show(bekreft)
          .then(angittMøtenummer => this.utførSlett(angittMøtenummer));

    }

    redigerSkjerming() {
        VisSkjermingDialog.visSkjermingDialog({
              entitetType: 'møte',
              gruppeId: () => this.moete.eiendeGruppeId,
              hentSkjerming: () => this.møteRes.hentSkjerming(this.moete.id).$promise,
              oppdaterSkjerming: (spesifikasjon: l.OppdaterSkjermingSpesifikasjon) => this.møteRes.oppdaterSkjerming(this.moete.id, spesifikasjon).$promise
          },
          this.$mdDialog)
          .then(() => this.relastMøte())
          .catch(_.noop);
    }

    endrePubliserMoete() {
        if (this.moete.tilgang.erMoetePublisert)
            this.møteTjeneste.opphevPubliseringenAvMøtet(this.moete.id);
        else
            this.møteTjeneste.publiserMøtet(this.moete);
    }

    endrePubliserProtokoll() {
        if (this.moete.tilgang.erProtokollPublisert)
            this.møteTjeneste.opphevPubliseringenAvProtokollen(this.moete.id);
        else
            this.møteTjeneste.publiserProtokoll(this.moete);
    }

    redigerProtokoll() {
        debug("redigerProtokoll")
        if (!this.aktivArkfaneProtokoll())
            return this.webNavigasjon.gåTilRedigerMøteProtokoll(this.aktivtMøteId());
        this.viserRedigerProtokoll = true;
    }

    startTranskripsjon() {
        this.møteTjeneste.startTranskripsjon(this.moete);
    }

    sendProtokollTilSignering() {
        //kan vi lavære å laste data på nytt her ? data vil så fremt atmosphere kjører bli relastet via oppdate-lytterne
        this.møteTjeneste.sendProtokollTilSignering(this.moete);
    }

    sendSignerProtokollPaaminnelse() {
        SendPåminelseOmSigneringDialog.visSendPåminelseOmSigneringDialog(this.moete.protokolldokumentId, this.$mdDialog);
    }

    markerProtokollSomFerdigSignert() {
        this.dokumentRes.hentGjeldendeDokumentversjon(this.moete.protokolldokumentId).$promise
          .then(dokument => AvsluttSigneringsprosessDialog.visAvsluttSigneringsprosessDialog(dokument, this.$mdDialog))
          .then(() => this.relastMøte())
          .catch(_.noop);
    }

    registrerEksterntSignertProtokoll() {
        RegistrerEksterntSignertProtokollDialog.visRegistrerEksterntSignertProtokollDialog(this.$mdDialog, this.moete);
    }

    viserMenypunktSendEpost(): boolean {
        return this.redigeringMulig;
    }

    /**
     * Hvis møte eller protokoll ikke er publisert - og bruker ikke har tilgang til ikke-publisert informasjon, så skal ikke meny-punktet vises.
     */
    viserMenypunktSeProtokollDokument(): boolean {
        // det vansligste er at man har tilgang. Så viser menypuntk hvis ikke møtet er tilgjengelig ennå.
        if (erNil(this.moete)) return true;
        if (this.moete.erMoetePublisert && this.moete.erProtokollPublisert) return true;
        if (!this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.tilgangIkkePublisert, this.moete.eiendeGruppeId)) return false;
        return true;
    }

    sendEpostMedMoete() {
        this.gruppeRes.hent(this.gruppe.id).$promise.then(g => {
            const valgbareMedlemmer = g.alleMedlemmer.filter(medlem => kanSendeEpost(medlem))
            this.ng2DialogTjenesterForAjs.sendEpostDialog(
              this.gettextCatalog.getString('E-post for {{moetenavn}} {{nummer}}', {moetenavn:this.moete.tittel, nummer: this.moete.nummer}),
              kopierFraAjsTilNg2(valgbareMedlemmer),
              this.moete.deltakere.map(d => d.medlem).filter(m => kanSendeEpost(m)).map(m => kopierFraAjsTilNg2(m)),
              this.sendEpostOmMoete.bind(this)
            );
        });

        function kanSendeEpost(medlem:l.GruppeMedlemListeModell) {
            return medlem.harTilgang && medlem.brukerId != null;
        }
    }

    // må matche signatur til metode i sendEpostDialog
    sendEpostOmMoete(epostTilMedlemmerSpesifikasjon: GenerellEpostTilMedlemmerSpesifikasjon): Promise<SendEpostResultatModell> {
        return this.møteRes.sendEpost(this.moete.id, epostTilMedlemmerSpesifikasjon).$promise as Promise<SendEpostResultatModell>;
    }

    laasOppProtokoll() {
        ///confirmdialog lås opp protokoll - kropp
        const htmlInnhold = this.gettextCatalog.getString('Protokollen for dette møte er sendt til signering. <br>Dersom du låser opp for redigering vil eventuelle registrerte signaturer slettes og protokollen må sendes til signering på nytt.');
        var bekreft = this.$mdDialog.prompt()
            ///confirmdialog lås opp protokoll - tittel
            .title(this.gettextCatalog.getString('Lås opp møte for redigering'))
            .htmlContent(`<div class="wt-dialog-prompt-kropp">${htmlInnhold}</div>`)
            ///confirmdialog lås opp protokoll - årsak-felt-label
            .placeholder('årsak')
            .required(true) //årsak må angis
            ///confirmdialog lås opp protokoll - ok-knapp
            .ok(this.gettextCatalog.getString('Lås opp'))
            ///confirmdialog lås opp protokoll - avbryt-knapp
            .cancel(this.gettextCatalog.getString('Avbryt'));
        this.$mdDialog.show(bekreft)
            .then(årsak => this.utførLåsOppProtokoll(årsak));
    }

    aapneMoetedokument() {
        if (this.redigeringMulig) return MøtedokumentValgDialog.visMøtedokumentValgDialog(this.$mdDialog, this.moete)
        this.$window.open(this.møteRes.møtedokumentUrl(this.moete), "_blank");
    }

    aapneAgendadokument() {
        window.open(this.møteRes.agendadokumentUrl(this.moete), "_blank");
    }

    aapneProtokolldokument() {
        window.open(this.møteRes.protokolldokumentUrl(this.moete), "_blank");
    }

    erFavoritt() {
        return this.favorittTjeneste.erFavoritt(this.moete);
    }

    endreFavorittmarkering() {
        this.favorittTjeneste.endreFavorittmarkeringForMøte(this.moete);
    }

    sendInnkalling() {
        this.møteTjeneste.sendInnkalling(this.moete);
    }

    aktivSak() {
        if (!_.isArray(this.moete?.saker)) return null;
        const sakId = this.aktivSakId();
        return _(this.moete.saker).find(sak => sak.id === sakId);
    }

    $onInit(): void {
        this.setAktivSakIValgtSakRegister();
        this.lyttTilNavigasjon();

        this.lyttTilDraOgSlippDokumenterIkkeAktivertDokumentSluppet();

        this.visDeltakerstatusOppdatertDersomForespurtIURL(this.$stateParams.deltakerstatus)
    }

    $onChanges(endringer: IOnChangesObject) {
        this.vedEndringer.next(endringer);
    }

    $onDestroy(): void {
        this.tilAvregistrering.forEach(avregistrering => avregistrering());
    }


    // hjelpemetoder

    private lastMøteVedOnChanges(){
        kallNedgradertNg2TjenesteVedEndring(
          this.$scope,
          this.vedEndringer,
          endring => endring.id?.currentValue as MøteId,
          this.møteDatatjenesteForAjs.tjeneste(),
          (møteId, møteDatatjeneste) => møteDatatjeneste.hentMedMeta(møteId, Leveringsvalg.lever_undefined_ved_slettet, FeilhåndteringsstrategiForDataOgMeta.propagerSomError)
        ).subscribe({
            next: dataOgMeta => {
                //dersom møte har blitt slettet fra lageret går vi til startsiden
                if (erNil(dataOgMeta.data)) return this.webNavigasjon.gåTilStartsiden();
                this.moeteNg2 = dataOgMeta.data;
                this.moete = kopierFraNg2TilAjs(dataOgMeta.data);
                this.initData();
            },
            error: feil => this.møteIkkeFunnet(feil)
        });
    }

    /** Setter aktiv sak i ValgtSakRegister - som benyttes i saksliste og saksdetaljer-visning i ng2 */
    private setAktivSakIValgtSakRegister(): void {
        this.valgtSakRegisterForAjs.tjeneste().then(valgtSakRegister => {
            erIkkeNill(this.sakId) ? valgtSakRegister.setValgt(this.sakId) : valgtSakRegister.nullstillValgt();
        });
    }

    private relastMøte(){
        this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste =>
          møteDatatjeneste.relast(this.moete.id));
    }

    private møteIkkeFunnet(respons: resource.IResourceResponse) {
        if (RessursFeilhåndtering.erStatus4XX(respons)) {
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt møte eksisterer ikke'));
            this.webNavigasjon.gåTilStartsiden();
            return;
        }

        this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Kunne ikke hente møte'));
    }

    private initData() {
        this.sakstidspunkterForAjs.tjeneste().then(sakstidspunkter => {
            sakstidspunkter.forMøteSomObserverbar(this.moete.id)
              .pipe(omsluttLeveringIAjsApplyAsync(this.$scope), takeUntilAjs$destroy(this.$scope))
              .subscribe(tidspunkter => this.beregnetSluttDato = MøteRessurs.beregnetMøtevarighet2(this.moete, tidspunkter.sakstidspunkter));
        });
        this.gruppe = this.kontekst.finnAutentiserteGruppe(this.moete.eiendeGruppeId);
        this.beregnetSluttDato = MøteRessurs.beregnetMøtevarighet(this.moete);
        this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.gruppe.id);
        this.visSendingInnkalling = moment(this.moete.dato.slutt).isAfter(moment()) && this.redigeringMulig;
        this.flerdagsmoete = Møtedatoer.erFlerdagsmøte(this.moete.dato);

        this.initProtokolSkalSigneresAvBruker().then(() => this.initIntroJs());
    }

    private utførLåsOppProtokoll(årsak:string) {
        return this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste =>
            møteDatatjeneste.låsOppProtokoll(this.aktivtMøteId(), årsak));
    }

    private initProtokolSkalSigneresAvBruker() {
        if (this.moete.protokollSigneringStatus != l.SigneringStatus.tilSignering && this.moete.protokollSigneringStatus != l.SigneringStatus.delvisSignert) {
            this.protokolSkalSigneresAvBruker = false;
            return this.$q.resolve();
        }
        //må laste deltakerdetaljer for å finne ut om bruker skal signere
        return this.protokollRes.deltakere(this.moete.id).$promise
            .then(deltakere => {
                this.protokollSkalsigneresAvNoen = _(deltakere.deltatte)
                  .concat(deltakere.forfalte)
                  .concat(deltakere.ikkeInnkalte)
                  .some(d => d.skalSignere);
                this.protokolSkalSigneresAvBruker = _(deltakere.deltatte)
                    .concat(deltakere.forfalte)
                    .concat(deltakere.ikkeInnkalte)
                    .filter(d => d.skalSignere && !d.harSignert)
                    .some(d => d.medlem.brukerId === this.kontekst.autentisertBrukersId());
            });
    }

    private aktivtMøteId() {
        return this.id
    }

    private aktivSakId() {
        return this.sakId
    }

    private visDeltakerstatusOppdatertDersomForespurtIURL(deltakerstatusParam) {
        let deltakerstatus = parseInt(deltakerstatusParam);
        let melding = null;
        switch (deltakerstatus) {
            case l.Deltakerstatus.akseptert:
                melding = this.gettextCatalog.getString('Du har akseptert invitasjonen til dette møtet');
                break;
            case l.Deltakerstatus.avslaatt:
                melding = this.gettextCatalog.getString('Du har avslått invitasjonen til dette møtet');
                break;
        }

        if (melding == null) return;

        //la siden laste før vi viser melding
        this.$timeout(() => this.meldingTilBruker.infomelding(melding), 3000);
    }

    private utførSlett(angittMøtenummer: string) {
        if (this.moete.nummer !== trimTilNull(angittMøtenummer)) {
            this.slett(true);
            return;
        }

        this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste =>
          møteDatatjeneste.slett(this.moete.id)
            //navigasjon til forsiden blir håndtert av koden som laster møte fra møteDatatjeneste
            //for at horisontal møte nav skal bli oppdatert
            .then(() => this.modelloppdatering.broadcastLokalSlettetMøte(this.moete.id)));
    }

    private lyttTilNavigasjon() {
        this.tilAvregistrering.push(this.$transitions.onSuccess({}, (trans: Transition) => {
            this.aktivArkfane = trans.params().aktivArkfane;
            this.sakId = trans.params().sakId
            this.setAktivSakIValgtSakRegister();
            this.initIntroJs();

            this.viserRedigerProtokoll = false;
            if (this.aktivArkfane == 'protokoll' && trans.params().rediger == true)
                this.redigerProtokoll();

            if(trans.paramsChanged().redigerRekkefølge == true)
                //må kalles asynkront for å unngå 'digest already in progress'-feil, merk at this.$scope.$evalAsync() gir også feil...
                setTimeout(()=> this.sakListeOgDetaljerKomponent.aktiverSortering(), 100);
        }));

        //Er redigering av protokoll forespurt?
        //Dersom bruker ikke står på møtesiden når feks webNavigasjon.gåTilRedigerMøteProtokoll kalles
        //vil denne koden håndtere at vi går til rediger-modus
        //Dersom bruker står på møtesiden vil sjekker over i $transitions.onSuccess(..) sørge for kall til this.redigerProtokoll()
        if (this.aktivArkfane == 'protokoll' && this.$stateParams.rediger === true)
            this.redigerProtokoll();
    }

    private lyttTilDraOgSlippDokumenterIkkeAktivertDokumentSluppet() {
        this.$scope.$on(BasisKontroller.eventer.draOgSlippDokumenterIkkeAktivertDokumentSluppet, () => {
           if (this.aktivSakId() != null) return;
           this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Du må klikke deg inn på saken for å legge til saksdokumenter'));
        });
    }

    private lyttTilPresentasjonsmodus() {
        this.presentasjonsmodusTjenesteForAjs.tjeneste().then(presentasjonsmodusTjeneste => {
            if (presentasjonsmodusTjeneste.erAktivert()) this.presentasjonsmodusAktivert = true;
        });
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusAktivert, () => this.presentasjonsmodusAktivert = true);
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusDeaktivert, () => this.presentasjonsmodusAktivert = false);
    }

    /**
     * Viser intro.
     */
    private initIntroJs() {
            if (this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive)) {
                return this.initIntroJsForAdmin(this.protokollSkalsigneresAvNoen);
            }
            return this.initIntroForMedlem(this.protokollSkalsigneresAvNoen);
    }

    private skalSigneres() {
        return this.protokollRes.deltakere(this.moete.id).$promise
          .then(deltakere => {
              return _(deltakere.deltatte)
                .concat(deltakere.forfalte)
                .concat(deltakere.ikkeInnkalte)
                .some(d => d.skalSignere);
          });
    }

    private initIntroForMedlem(visSignaturTips: boolean) {
        this.introJs.visIntroForsinket(
            this.introJs.nyIntroduksjon('møteside')
                .leggTilSteg(
                    1,
                    {
                        title: this.gettextCatalog.getString('Protokollsiden'),
                        intro: this.gettextCatalog.getString('Her ligger protokollen for dette møtet, og det er her du både leser og signerer den.')
                    },
                    () => this.aktivArkfaneProtokoll()
                )
                .leggTilSteg(
                    2,
                    {
                        title: this.gettextCatalog.getString('Møtehjelperen'),
                        intro: this.gettextCatalog.getString('Møtehjelperen viser deg hva du skal gjøre for dette møtet, som å godta innkalling eller signere protokollen.'),
                        element: '[data-tips-id="moete-tilstand"]',
                        position: 'left'
                    }
                )
                .leggTilSteg(
                    3,
                    {
                        title: this.gettextCatalog.getString('Møtenavigering'),
                        intro: this.gettextCatalog.getString('Bytt mellom saksliste, protokoll og avstemninger.'),
                        element: '[data-tips-id="moete-navigasjon"]',
                        position: 'right'
                    }
                )
                .leggTilSteg(
                    4,
                    {
                            title: this.gettextCatalog.getString('Sakslisten'),
                            intro: this.gettextCatalog.getString('Her ligger alle sakene i dette møtet. Trykk på en sak for å åpne den, lese saksinformasjon, skrive sakskommentarer og annotere på eventuelle saksdokumenter.'),
                            element: "wm-moete-saksliste",
                            position: "right"
                        },
                        () => this.aktivArkfane == 'saker' && this.moete?.saker?.length > 0
                )
                .leggTilSteg(
                    5,
                    {
                        title: this.gettextCatalog.getString('Signering'),
                        intro: this.gettextCatalog.getString('Når du bes om å signere protokollen, trykker du SIGNER i ditt eget signaturfelt.'),
                        element: '[data-tips-id="signaturfelter"]'
                    },
                    () => this.aktivArkfaneProtokoll() && visSignaturTips
                ),
                1000
        );
    }

    private initIntroJsForAdmin(visSignaturTips: boolean) {
        const visRedigerTips = !this.moete.laastForRedigering && this.redigeringMulig;
        this.introJs.visIntroForsinket(
            this.introJs.nyIntroduksjon('møteside.admin')
                .leggTilSteg(
                    1,
                    {
                        title: this.gettextCatalog.getString('Protokollsiden'),
                        intro: this.gettextCatalog.getString('Her ligger protokollen for dette møtet, og det er her du både leser og signerer den.')
                    },
                    () => this.aktivArkfaneProtokoll()
                )
                .leggTilSteg(
                    2,
                    {
                        title: visRedigerTips ? this.gettextCatalog.getString('Redigering og møtemeny') : this.gettextCatalog.getString('Møtemeny'),
                        intro:
                            (visRedigerTips ? this.gettextCatalog.getString('For å redigere møtedetaljene (tid, sted, deltakere, mm.) trykker du på blyant-ikonet.') + '<br /><br />' : '')
                            + this.gettextCatalog.getString('I møtemenyen finner du all funksjonalitet på møtenivå. For funksjonalitet på saksnivå bruker du menyen på den konkrete saken.'),
                        element: '[data-tips-id="moete-menyer"]',
                        position: 'left'
                    }
                )
                .leggTilSteg(
                    3,
                    {
                        title: this.gettextCatalog.getString('Møtehjelperen'),
                        intro: this.gettextCatalog.getString('Møtehjelperen støtter deg i prosessen, fra registrering av saker til signering av protokollen. Hvert steg er en klikkbar lenke.'),
                        element: '[data-tips-id="moete-tilstand"]',
                        position: "left"
                    }
                )
                .leggTilSteg(
                    4,
                    {
                        title: this.gettextCatalog.getString('Møtenavigering'),
                        intro: this.gettextCatalog.getString('Saker: Forbered sakene til møtet.<br /><br />Protokoll: Klargjør protokollen etter møtet.<br /><br />Avstemninger: Klargjør og gjennomfør avstemninger.'),
                        element: '[data-tips-id="moete-navigasjon"]',
                        position: "right"
                    },
                )
                .leggTilSteg(
                    5,
                    {
                        title: this.gettextCatalog.getString('Sakslisten'),
                        intro: this.gettextCatalog.getString('Her ser du sakslisten. Du kan endre saksrekkefølgen ved å klikke og dra i sakene.<br /><br />Trykk på en sak for å åpne den, lese saksinformasjon, redigere, skrive sakskommentarer og annotere på eventuelle saksdokumenter.'),
                        element: 'wm-moete-saksliste',
                        position: 'right'
                    },
                    () => this.aktivArkfane == 'saker' && this.moete?.saker?.length > 0
                )
                .leggTilSteg(
                    6,
                    {
                        title: this.gettextCatalog.getString('Ny sak'),
                        intro: this.gettextCatalog.getString('Legg til nye møtesaker nederst i sakslisten ved å skrive inn sakstittelen.'),
                        element: '[data-tips-id="ny-sak-skjema"]',
                        position: 'top'
                    },
                   () => this.aktivArkfane == 'saker' && this.moete?.saker?.length > 0 && visRedigerTips
                )
                .leggTilSteg(
                    7,
                    {
                        title: this.gettextCatalog.getString('Saksmeny'),
                        intro: this.gettextCatalog.getString('Bruk saksmenyen for å redigere saksinformasjonen.'),
                        element: '[data-tips-id="saksmeny"]',
                        position: "top"
                    },
                    () => erIkkeNill(this.sakId)
                )
                .leggTilSteg(
                    8,
                    {
                        title: this.gettextCatalog.getString('Legg til saksinnhold'),
                        intro: this.gettextCatalog.getString('Bruk pluss-ikonet til å laste opp dokumenter, lage oppgaver og avstemninger, samt skrive beslutningsforslag og kommentarer.'),
                        element: '[data-tips-id="sak-legg-til-knapp"]',
                        position: "right"
                    },
                    () => erIkkeNill(this.sakId)
                )
                .leggTilSteg(
                    9,
                    {
                        title: this.gettextCatalog.getString('Redigering av protokollen'),
                        intro: this.gettextCatalog.getString('Trykk på blyanten for å redigere protokollen, herunder møtedeltakelse, signatarer, referattekster og beslutninger.'),
                        element: '[data-tips-id="protokoll-meny"]'
                    },
                    () => this.aktivArkfaneProtokoll() && !this.moete.laastForRedigering
                )
                .leggTilSteg(
                    10,
                    {
                        title: this.gettextCatalog.getString('Signering'),
                        intro: this.gettextCatalog.getString('Når du bes om å signere protokollen, trykker du SIGNER i ditt eget signaturfelt.'),
                        element: '[data-tips-id="signaturfelter"]'
                    },
                    () => this.aktivArkfaneProtokoll() && visSignaturTips
                ),
            1000
        );
    }
}
